export default function ResultSection({ children, className, final, red }) {
  return (
    <div
      className={`ResultSection ${className != null ? className : ""} ${final ? "final" : ""} ${red ? "red" : ""
        }`}
    >
      {children}
    </div>
  );
}
